import Nav from 'react-bootstrap/esm/Nav'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  background: #2e2e2e;
  color: #fff;
  margin: 0 -15px;
  padding-top: 0.5rem;

  .nav-tabs {
    display: flex;
    justify-content: center;
  }

  .tab-pane {
    .nav-link {
      color: #000;
    }
  }
`

export const StyledUL = styled.ul`
  margin: 0 !important;
`

export const StyledDesktopBeltNav = styled(Nav).attrs({
  variant: 'tabs'
})``

export const StyledBody = styled.div`
  background: #fff;
  color: #000;
  padding: 0 15px 15px 15px;
`
